export const ApplicationStep = {
    Authentication: "/authentication"
};